import React from "react";
import { Container, Title } from "../FaleConosco/FaleConoscoStyles";
import Footer from "../../components/Footer";

const FaleConosco = () => {
  return (
    <>
      <Container>
        <Title></Title>
      </Container>
      <Footer />
    </>
  );
};

export default FaleConosco;
